import { render, staticRenderFns } from "./CustomCheckerboardEdit.vue?vue&type=template&id=8993cd96"
import script from "./CustomCheckerboardEdit.vue?vue&type=script&lang=js"
export * from "./CustomCheckerboardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports